import React, { useState } from 'react';
import {
  Box,
  Icon,
  TextField,
  Typography,
  InputAdornment
} from '@material-ui/core';


const SearchGroupField = ({ onSearch }) => {
  const [searchValue, setSearchValue] = useState('');

  const handleSearchValueChange = (event) => {
    const {value} = event.target;
    setSearchValue(value);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onSearch(searchValue);
    }
  };

  const handleSearchSubmit = () => {
    onSearch(searchValue);
  };

  const handleClearSearch = () => {
    setSearchValue('');
    onSearch('');
  };

  return (
    <Box className="my-8">
      <Typography variant="h6" gutterBottom>
        Search
      </Typography>
      <form>
        <TextField
          placeholder="Marketing Segment"
          fullWidth
          variant="outlined"
          value={searchValue}
          onChange={handleSearchValueChange}
          onKeyPress={handleKeyPress}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Icon
                  color="primary"
                  onClick={handleSearchSubmit}
                >
                  search
                </Icon>
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {searchValue.length > 0 && (
                  <Icon
                    color="primary"
                    className="cursor-pointer"
                    onClick={handleClearSearch}
                  >
                    close
                  </Icon>
                )}
              </InputAdornment>
            )
          }}
        />
      </form>
    </Box>
  );
};

export default SearchGroupField;
